import * as React from 'react';
import * as I18n from 'i18n-js';

interface IProps {
  sellerCostDisplay: string;
}

export default function OfferListingSellerCost(props: IProps) {
  if (!props.sellerCostDisplay) {
    return null;
  }

  return (
    <div className="modal-sidebar-listing__detail">
      <dt>{I18n.t('discovery.offers.sellerCost')}</dt>
      <dd>{props.sellerCostDisplay}</dd>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/offers/offer_listing_seller_cost.tsx